import { TrackingData } from '@hooks/analytics/typings'

// Rakanto tag removed (unapproved third-party vendor). Tracking is handled by the
// Adobe data layer in `src/analytics/adobe`; these stay as no-ops until the
// remaining call sites are migrated off this module.
const getAnalytics = () => {
  // only call on router events
  const trackPage = (_pathname: string) => {}

  const trackCustomEvent = (_data: TrackingData) => {}

  return {
    trackPage,
    trackCustomEvent,
  }
}

const analytics = getAnalytics()

export default analytics
